<template>
  <div v-show="!initialLoading">
    <b-modal
      data-backdrop="static"
      :hide-footer="true"
      id="invoice-details-modal"
      :clickToClose="false"
      ref="invoice-details-modal"
      size="xl"
      :style="'z-index: 2500'"
      headerClass="order-detail-header-modal pb-0"
      contentClass="flexben-container order-detail-modal"
      bodyClass="order-detail-modal"
      centered>


      <div slot="modal-header">
        <div class="row">
          <div class="col-12 d-flex justify-content-between align-items-center text-36">
            <button type="button" aria-label="Close" class="close text-danger ml-auto" @click="closeModal">×</button>
          </div>
        </div>
      </div>

      <template v-slot:default="{ hide }">
        <div class="container-bg-white mb-3">
          <div class="row mb-4 ml-2">
            <div class="col-12 text-18 font-weight-bold pt-2">
              {{$t("flexben.invoice.invoice_details.details")}}
            </div>
          </div>
          <hr>
          <div class="row mb-2 ml-2">
            <div class="col-2 col-md-3 d-flex align-items-center mb-2">
                    <span class="font-weight-bold mr-2">
                        {{ $t("flexben.invoice.invoice_details.details_data.invoice_id") }}:
                    </span>
              {{ invoice.external_id}}
            </div>


            <div class="col-2 col-md-3 d-flex align-items-center">
                    <span class="font-weight-bold mr-2">
                        {{ $t("flexben.invoice.invoice_details.details_data.client_name") }}:
                    </span>
              {{ invoice.company.name }}
            </div>
            <div class="col-2 col-md-3 d-flex align-items-center">
                    <span class="font-weight-bold mr-2">
                        {{ $t("flexben.invoice.table.period") }}:
                    </span>
              {{invoice.start_date + ' - ' + invoice.end_date }}
            </div>
            <div class="col-2 col-md-3 d-flex align-items-center mb-2">
                    <span class="font-weight-bold mr-2">
                        {{ $t("flexben.invoice.invoice_details.details_data.client_id") }}:
                    </span>
              {{ invoice.company.identifier }}
            </div>
          </div>
          <hr>
          <div class="row mb-2 ml-2 ">
            <div class="col-12 col-md-3 d-flex align-items-center mb-2">
                    <span class="font-weight-bold mr-2">
                        {{ $t("flexben.invoice.table.status") }}:
                    </span>
              {{ $t("flexben.invoice.table.status_list." + invoice.status)}}
            </div>
            <div class="col-12 col-md-3 d-flex align-items-center mb-2">
                    <span class="font-weight-bold mr-2">
                        {{ $t("flexben.invoice.table.type") }}:
                    </span>
              {{ $t("flexben.invoice.table.types." + invoice.type)}}
            </div>
            <div class="col-12 col-md-3 d-flex align-items-center mb-2">
                    <span class="font-weight-bold mr-2">
                        {{ $t("flexben.invoice.table.source") }}:
                    </span>
              {{ $t("flexben.invoice.table.sources." + invoice.source)}}
            </div>
            <div class="col-12 col-md-3 d-flex align-items-center mb-2">
                    <span class="font-weight-bold mr-2">
                        {{ $t("flexben.invoice.invoice_details.details_data.details") }}:
                    </span>
              {{ invoice.description ? invoice.description : ' - '}}
            </div>
          </div>
          <hr>
          <div class="row mb-2 ml-2">

            <div class="col-12 text-16 font-weight-bold">
              <img src="@/assets/images/filter.svg"/>
              {{$t("flexben.invoice.invoice_details.details_data.filters.title")}}
            </div>


          </div>
          <div class="row mb-2 ml-2">
            <div class="col-6 col-md-3 mb-2">
              <label for="select_partner" class="form-label mr-4 font-weight-bold">
                {{ $t("flexben.invoice.invoice_details.details_data.filters.partner") }}
              </label>
              <select class="form-control" v-model="params.partner" id="select_partner">
                <option :value="null">{{ $t("flexben.general.all") }}</option>
                <option v-for="partner in filterOptions.partners" :key="partner.id" :value="partner.id">
                  {{ partner.name }}
                </option>
              </select>
            </div>
            <div class="col-6 col-md-3 mb-2">
              <label for="select_type" class="form-label mr-4 font-weight-bold">{{
                $t("flexben.invoice.invoice_details.details_data.filters.benefit")
                }}</label>
              <select class="form-control" v-model="params.benefitType" id="select_type">
                <option :value="null">{{$t("flexben.general.all")}}</option>
                <option v-for="subType in filterOptions.benefit_sub_types" :key="subType" :value="subType">
                  {{$t("flexben.benefit.sub_types." + subType )}}
                </option>
              </select>
            </div>
          </div>

        </div>

        <div class="container-bg-white">

          <div class="col-12 text-18 font-weight-bold pt-2">
            {{$t("flexben.invoice.invoice_details.requests")}}
          </div>

          <div class="row px-3 pt-3">
            <div v-if="invoice.type === 1" class="col-3 col-md-3 d-flex align-items-center mb-2">
              <button class="btn btn-themed px-4 mr-2 mt-2"
                      @click="creditItems()">
                {{ $t("flexben.invoice.invoice_details.details_data.buttons.credit") }}
              </button>
            </div>
            <div v-if="invoice.type === 1" class="col-3 col-md-3 d-flex align-items-center mb-2">
              <button class="btn btn-themed px-4 mr-2 mt-2"
                      @click="creditInvoice()">
                {{ $t("flexben.invoice.invoice_details.details_data.buttons.credit_all") }}
              </button>
            </div>

            <div class="col-3 col-md-3 d-flex align-items-center mb-2">
              <button class="btn btn-themed px-4 mr-2 mt-2"
                      @click="downloadInvoice()">
                {{ $t("flexben.invoice.invoice_details.details_data.buttons.download_invoice") }}
              </button>
            </div>
          </div>
          <div v-if="invoice.type ===1 " class="row px-3 pt-3">
            <div class="col-4 col-md-4 align-items-center mb-2 ml-2 grey-card">
              <label class="m-0 form-fields col-form-label bold" for="description">
                {{ $t('flexben.invoice.invoice_details.details_data.details_invoice') }}</label>
              <input id="description" v-model="description"
                     class="form-control m-0 w-100 background-grey border-box"
                     type="text">
            </div>

          </div>
          <div class="row px-3 pt-3">
            <div class="col-12 table-order-request">
              <div class="table-responsive mt-3 hover-table">
                <table class="table-flx table table-striped">
                  <thead>

                  <tr>
                    <td>{{$t("flexben.invoice.invoice_details.details_data.buttons.select")}}
                      <input type="checkbox" id="check_all" v-model="checkedAll" @change="checkAll()"
                             class="cursor-pointer"/>
                    </td>
                    <td>{{$t("flexben.invoice.invoice_details.table.order_request_id")}}</td>
                    <td>{{$t("flexben.invoice.invoice_details.table.company_employee")}}</td>
                    <td>{{$t("flexben.invoice.invoice_details.table.partner")}}</td>
                    <td>{{$t("flexben.invoice.invoice_details.table.benefit_name")}}</td>
                    <td>{{$t("flexben.invoice.invoice_details.table.benefit_sub_type")}}</td>
                    <td>{{$t("flexben.invoice.invoice_details.table.quantity")}}</td>
                    <td>{{$t("flexben.invoice.invoice_details.table.value")}}</td>
                    <td>{{$t("flexben.invoice.invoice_details.table.vat")}}</td>
                    <td>{{$t("flexben.invoice.invoice_details.table.vat_value")}}</td>
                    <td>{{$t("flexben.invoice.invoice_details.table.status")}}</td>
                    <td>{{$t("flexben.invoice.invoice_details.table.status_invoice")}}</td>

                    <td>{{$t("flexben.invoice.invoice_details.table.placed_at")}}</td>
                  </tr>
                  </thead>
                  <tbody>
                  <template v-if="list.data.length>0">
                    <tr v-for="(item) of list.data" :key="item.id"
                        class="trhover parent">
                      <td class="w-25-p">
                        <input v-show="item.order_request ? item.order_request.status_invoice === 3 : true"
                          type="checkbox"
                               style="transform: scale(1.4)"
                               :checked="checkIds.includes(item.id)"
                               :value="item.id"
                               @change="selectForCredit(item.id)"

                        />
                      </td>
                      <td>{{ item.order_request_id ? item.order_request_id : '-' }}</td>
                      <td>{{ (item.company_employee ? item.company_employee.first_name : '') + ' ' +
                        (item.company_employee ? item.company_employee.last_name : ' .,-') }}
                      </td>
                      <td>{{ item.partner.name}}</td>
                      <td>{{ item.name}}</td>
                      <td>{{ item.benefit_sub_type ? $t("flexben.benefit.sub_types." + item.benefit_sub_type ) : '-'
                        }}
                      </td>
                      <td>{{ item.quantity }}</td>
                      <td>{{ item.total_value }}</td>
                      <td>{{ item.vat}}</td>
                      <td>{{ item.vat_value}}</td>
                      <td>{{ item.order_request ? $t("flexben.requests.summary.status_new." +
                        item.order_request.status_new ) : '-'}}
                      <td>{{ item.order_request ? $t("flexben.requests.summary.status_invoice." +
                        item.order_request.status_invoice ) : '-'}}
                      </td>
                      <td class="text-bold">{{item.order_request ? item.order_request.placed_at : 'N/A' }}</td>

                    </tr>
                  </template>
                  <template v-else>
                    <tr class="trhover gri-cell">
                      <td colspan="100" class="text-center">{{ $t("flexben.general.no_results_found") }}
                      </td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-12 p-0">
              <listPagination
                :activePage="list.current_page"
                :currentPage="list.current_page"
                :totalItems="list.total"
                :startItem="list.from"
                :endItem="list.to"
                :itemsPerPage="list.perPage"
                @pageChanged="pageChanged"
                @changePerPage="changePerPage"></listPagination>
            </div>
          </div>
        </div>

      </template>


    </b-modal>
    <content-loader :loader-visible="loading" :loader-error="loaderError"></content-loader>
    <AlertModal :message="alertModal.message"
                :textClass="alertModal.class"
                :failed="alertModal.failed"
                ref="alert-modal"
                @clearActionSuccess="clearActionSuccess"/>
  </div>
</template>

<script>
import httpFlexbenService from "@/http/http-flexben";
import {saveAs} from "file-saver";
import AlertModal from "@/components/flexben/beneficiary_pages/partials/AlertModal";

export default {
  name: "InvoiceDetails",
  components: {
    AlertModal
  },
  data: () => {
    return {
      httpService: httpFlexbenService.invoices,
      initialLoading: true,
      loading: true,
      loaderError: false,
      invoice: null,
      description: null,
      checkedAll: false,
      checkIds: [],
      params: {
        page: 1,
        perPage: 20,
        partner: null,
        benefitType: null
      },
      filterOptions: {
        page: 1,
        perPage: 20,
        partners: [],
        benefit_sub_types: [],
      },
      list: {
        data: [],
        current_page: 1,
        to: 1,
        perPage: 1,
        lastPage: 1,
        total: 1
      },
      alertModal: {
        class: null,
        message: null,
        failed: false
      },
    }
  },
  watch: {
    'params.benefitType': function () {
      this.resetPagination();
      this.loadList();
    },
    'params.partner': function () {
      this.resetPagination();
      this.loadList();
    }
  },
  methods: {
    show(invoice) {
      this.initialLoading = false;
      this.invoice = invoice;
      this.loadList();
    },
    loadList() {
      this.loading = true;
      this.httpService.items(this.invoice.id, this.params)
        .then((response) => {
          return response.data;
        })
        .then((data) => {
          let items = data.data;
          let filters = data.filters;

          this.list = {
            data: items.data,
            current_page: items.current_page,
            to: items.to,
            perPage: items.perPage,
            lastPage: items.lastPage,
            total: items.total
          };

          this.filterOptions.partners = filters.partners;
          this.filterOptions.benefit_sub_types = filters.benefit_sub_types;

          this.initialLoading = false;
          this.loading = false;
          this.openModal();
          // this.$refs['invoice-details-modal'].show();
        })
        .catch((error) => {
          console.log(error)
          this.list = {
            data: [],
            current_page: 1,
            to: 1,
            perPage: 1,
            lastPage: 1,
            total: 1
          };

          if (error.response.status >= 500 && error.response.status < 600) {
            this.loading = false;
            this.loaderError = true;
            this.initialLoading = false;
          }
        });
    },
    resetPagination() {
      this.params.page = 1;
      this.params.perPage = 20;
    },
    closeModal() {
      this.resetModal();
      this.$refs['invoice-details-modal'].hide();
      this.$emit('loadIndex');

    },
    openModal() {
      this.$refs['invoice-details-modal'].show();
    },
    creditInvoice() {
      //collect order requests ids
      this.loading = true;

      let payload = {
         invoice_id: this.invoice.id,
         company_id: this.invoice.company_id,
         description: this.description
      };
      this.httpService.credit(payload)
        .then((response) => {
          this.loading = false;
          this.showAlertModal(true)
          this.closeModal();
        }).catch((error) => {
        if (error.response.status >= 500 && error.response.status < 600) {
          this.loading = false;
          this.loaderError = true;
          this.initialLoading = false;
        }
      });
    },
    creditItems() {
      this.loading = true;

      let payload = {
        item_ids: this.checkIds,
        company_id: this.invoice.company_id,
        description: this.description
      };

      this.httpService.credit(payload)
        .then((response) => {
          this.loading = false;
          this.showAlertModal(true)
          this.closeModal();
        }).catch((error) => {
        if (error.response.status >= 500 && error.response.status < 600) {
          this.loading = false;
          this.loaderError = true;
          this.initialLoading = false;
          this.showAlertModal(false)
        }
      });
    },
    downloadInvoice() {
      this.loading = true;
      this.httpService.getPdf(this.invoice.id)
        .then((response) => {
          if (response.status === 200) {
            let blob = new Blob([response.data], { type: 'application/pdf' });
            saveAs(blob, 'invoice-' + this.invoice.id + ".pdf");
          }
          this.loading = false;
        }).catch((error) => {
        this.loading = false;
        this.loaderError = true;
        this.initialLoading = false;
      });
    },
    selectForCredit(id) {
      let index = this.checkIds.indexOf(id);
      if (index === -1) {
        this.checkIds.push(id);

        if (this.checkIds.length === this.list.data.length) {
          this.checkedAll = true;
        }
      } else {
        this.checkIds.splice(index, 1);
        this.checkedAll = false;
      }
    },
    changePerPage(perPage) {
      this.params.page = 1;
      this.params.perPage = perPage;
      this.loadList(this.invoice);
    },
    pageChanged(page) {
      this.params.page = page;
      this.loadList(this.invoice);
    },
    checkAll() {
      if (!this.checkedAll) {
        this.checkIds = [];
      } else {
        this.list.data.forEach((item) => {
          let canBeCredited = item.order_request ? item.order_request.status_invoice === 3 : true;
          if (canBeCredited) {
            this.checkIds.push(item.id);
          }
        })
      }
    },
    showAlertModal(isSuccess = true) {
      if (isSuccess) {
        this.alertModal.class = 'text-success';
        this.alertModal.message = this.$t('flexben.invoice.alert_messages.credit.success');
        this.alertModal.failed = false;
      } else {
        this.alertModal.class = 'text-danger';
        this.alertModal.message = this._getErrorBag(this.errorsBag).join('<br>');
        this.alertModal.failed = true;
      }
      this.$refs['alert-modal'].openModal();
    },
    clearActionSuccess() {
      this.actionSuccess = null;
      this.alertModal = {
        class: null,
        message: null,
        failed: false,
      };
    },
    resetModal() {
      this.params = this.$options.data.call(this).params;
      this.filterOptions = this.$options.data.call(this).filterOptions;
      this.list = this.$options.data.call(this).list;
      this.description = null;
      this.checkedAll = false;
      this.checkIds = [];

    },
  }
}
</script>

<style scoped>

</style>
